import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication } from "@azure/msal-browser";
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import "./index.css";
import App from "./App";
import { msal as msalConfig } from "./config";

export const msalInstance = new PublicClientApplication(msalConfig);

// MSAL v4: initialize() must complete before any MSAL API call.
msalInstance.initialize().then(() => {
	const root = ReactDOM.createRoot(
		document.getElementById("root") as HTMLElement
	);
	root.render(<App msalInstance={msalInstance} />);
});
